import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {WhatsNewService} from '../shared/services/whats-new.service';
import {GlobalSettingsService} from '../shared/services/global-settings.service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-whatsnew',
  templateUrl: './whatsnew.component.html',
  styleUrls: ['./whatsnew.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WhatsnewComponent implements OnInit, AfterViewInit {
  // whatsnewVersion: string = null;
  whatsnewTitle: string = null;
  whatsnewText: string = null;
  whatsnewURL: string = null;
  // localStorageInfo = this._globalSettingsService.localStorageInfo$;

  constructor(public dialogRef: MatDialogRef<WhatsnewComponent>,
              private whatsnewService: WhatsNewService,
              private _globalSettingsService: GlobalSettingsService) { }

  ngOnInit() {
    /* const response = await this.whatsnewService.getWhatsNew('1.4.3');
    this.whatsnewTitle = response.title;
    this.whatsnewText = response.text;
    this.whatsnewURL = response.url; */
    /* this._globalSettingsService.loadInfo();
    this.localStorageInfo.subscribe(val => {
      console.log(val);
      if (val && val.whatsNewVersion) {
        this.whatsnewVersion = val.whatsNewVersion;
      }
    }); */
    // console.log('localStorageInfo: ', this.localStorageInfo);
  }

  async ngAfterViewInit() {
    // setTimeout(async () => {
      const response = await this.whatsnewService.getWhatsNew(environment.version);
      if (!response.whatsnew_text) {
        this.dismiss();
      }
      this.whatsnewTitle = response.title;
      this.whatsnewText = response.whatsnew_text;
      this.whatsnewURL = response.whatsnew_more_url;
    // }, 3000);
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itse1lf and optionally pass back data
    this.dialogRef.close({
      dismissed: true
    });
    // this.whatsnewService.displayedWhatsNew();
  }
}
